export default __webpack_public_path__ + "static/media/wallpaper_bg2.49f3a8b0.png";